import Axios from "../BaseAxios";
import { API_CLIENT_URL } from "../../constants/urls";
import Keys from "../../constants/keys";

const StudentApiHelper = {
  getStudentDetails: (
    studentId,
    successHandler = null,
    failureHandler = null
  ) => {
    let requestParams = {};

    requestParams[Keys.STUDENT_ID] = studentId;
    Axios.request_GET(
      API_CLIENT_URL.studentDetails,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
};

export default StudentApiHelper;
